import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-fifth-step',
  templateUrl: './fifth-step.component.html',
  styleUrls: ['./fifth-step.component.scss']
})
export class FifthStepComponent implements OnInit {

  @Output() finish = new EventEmitter<Boolean>();

  constructor() { }

  ngOnInit(): void {
    localStorage.removeItem('calculationForm');
    localStorage.removeItem('calculationParams');
    localStorage.removeItem('noteForm');
  }

  onSubmit(): void{
    this.finish.emit(true)
  }

}
